class StayAIBundleBuilder extends HTMLElement {
  constructor() {
    super();
    const bundleBlocks = document.querySelectorAll(".lsg-bundle-block");
    this.productSelectionButtonClicked = false;
    this.productSelectionIndex = "";
    this.selectedProducts = bundleBlocks.length > 0
      ? [...bundleBlocks].map(() => [...[]])
      : this.selectedProducts;
  }
}
customElements.define("stay-ai-bundle-builder", StayAIBundleBuilder);

class StayAIBundleProduct extends StayAIBundleBuilder {
  constructor() {
    super();
    this.productJSON = this.getAttribute("product");
    this.product = JSON.parse(this.productJSON);
    this.bundleIndex = this.getAttribute("bundle-index");
    this.bundleMin = this.getAttribute("bundle-min");
    this.bundleMax = this.getAttribute("bundle-max");
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  connectedCallback() {
    this.addToCartButton = this.querySelector("[data-bundle-atc]");
    this.addToCartButtonQuantity = this.querySelector("[data-bundle-atc-missing-quantity]");
    this.selectedVariantWrapper = this.querySelectorAll("[data-bundle-builder-selected-variant-id]");

    this.loadEventListeners();
    this.initializeBundle();
    this.loadBundleObserver();

    // Preselect first interval option
    this.querySelectorAll('.lsg-bundle-interval-select input[name^="bundle_interval_select_"]')[0].checked = true
  }

  initializeBundle() {
    const intervalSelect = this.querySelector('.lsg-bundle-interval-select');
    const sellingPlanInput = this.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    const frequencySelect = this.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
    const bundleProductSetList = this.querySelectorAll(".stay-ai-bundle-product__cards");
    
    if(intervalSelect){
      this.classList.add('lsg-bundle--has-interval-select');
      let selectedIntervalWrapper = intervalSelect.querySelector('input[name^="bundle_interval_select_"]');
      const selectedInterval = selectedIntervalWrapper.value
      const hasSubscriptionInterval = selectedInterval === 'otp' || selectedInterval === 'sub'
      
      if (!selectedIntervalWrapper || !hasSubscriptionInterval) return
      const isOneTimePurchase = selectedInterval === 'otp' 
      const intervalSelectorClass = isOneTimePurchase ? 'lsg-bundle--otp-selected' : 'lsg-bundle--sub-selected';

      this.classList.add(intervalSelectorClass)
      sellingPlanInput.value = isOneTimePurchase ? '' : frequencySelect.value;
    } 

    bundleProductSetList.forEach((productSetList) => {
      const quantityInput = productSetList.querySelector('.stay-ai-bundle-product__quantity');
      this.totalSelectedQtyValidation(quantityInput);
    });

    this.checkoutEnableValidation(sellingPlanInput);
    this.checkParameter();
    this.classList.add('is-initialized');
  }

  loadEventListeners() {
    //Event Listeners
    window.addEventListener('pageshow', function (event) {
      if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
        this.querySelectorAll('.stay-ai-bundle-product__quantity').forEach((input) => {
          input.value = 0;
          this.inputChangeSubProduct(input);
          this.totalSelectedQtyValidation(input);
          this.checkoutEnableValidation(input);
        }).bind(this);
      }
    },
    false);
    this.querySelectorAll('[data-bundle-builder-selected-product-remove-button]').forEach((removeButton) => {
      removeButton.addEventListener('click', this.removeButtonEvent.bind(this));
    });
    
    this.querySelectorAll('.stay-ai-bundle-product__quantity-selector').forEach((quantitySelector) => {
      quantitySelector.addEventListener("click", this.toggleQuantityEvent.bind(this));
    });
    this.querySelectorAll('.stay-ai-bundle-product__quantity').forEach(function(input){
      input.addEventListener('change', function(e){
          this.inputChangeSubProduct(e.currentTarget);
          this.totalSelectedQtyValidation(e.currentTarget);
          this.checkoutEnableValidation(e.currentTarget);
      })
    });
    this.querySelectorAll('.lsg-bundle-interval-select input[name^="bundle_interval_select_"]').forEach(function(intervalSelector){
      intervalSelector.addEventListener('change', (e) => {
        this.updateInterval(e.currentTarget);
        this.checkoutEnableValidation(e.currentTarget);
        this.setUrl(e.currentTarget);
      });
    }.bind(this));
    this.querySelectorAll('.lsg-bundle-interval-frequency-select').forEach(function(frequencySelect){
      frequencySelect.addEventListener('change', (e) => {
        const trigger = e.currentTarget;
        this.updateFrequency(e.currentTarget);
        this.setUrl(e.currentTarget);
      })
    }.bind(this));
    this.querySelectorAll('[data-bundle-atc]').forEach(function (bundleATC) {
      bundleATC.addEventListener('click', (e) => {
        e.preventDefault();
        if(e.currentTarget.classList.contains('disabled')) {
          //scroll to top of the bundle block
          const announcementOffset = parseInt(document.body.style.getPropertyValue('--announcement-offset').replace('px', '')) || 0;
          const headerOffset = parseInt(document.body.style.getPropertyValue('--header-offset').replace('px', '')) || 0;
          const offset = announcementOffset + headerOffset;
          const bundleBlock = this.getBundleBlock(e.currentTarget);
          window.scrollTo({ top: bundleBlock.offsetTop - offset, behavior: 'smooth' });
        } else {
          this.addToCart(e.currentTarget);
        }
      })
    }.bind(this));
    this.querySelectorAll('.lsg-bundle-size-select-el').forEach(function(bundleSelector) {
      bundleSelector.addEventListener('click', (e) => {
        e.preventDefault();
        this.setActiveBundle(e.currentTarget);
      })
    }.bind(this));
    this.addToCart
  }

  /**
   * Removes selected product
   * @param {EventListener} event - Remove icon event
   */
  removeButtonEvent(event) {
    event.preventDefault();

    const triggeredProductWrapper = event.target.closest("[data-bundle-builder-selected-variant-id]");
    this.productSelectionButtonClicked = true;
    this.productSelectionIndex = triggeredProductWrapper.getAttribute("data-index");

    const variantID = triggeredProductWrapper.getAttribute("data-bundle-builder-selected-variant-id");
    const bundleProduct = this.querySelector(`[data-lsg-bundle-variant-select-id='${variantID}']`);
    const bundleProductDecrement = bundleProduct.querySelector(".lsg-bundle-product-select-quantity-minus");
    bundleProductDecrement.click();
  }

    /**
   * Toggles quantity selector on selected product
   * @param {EventListener} event - Quantity plus minus icon event
   */
    toggleQuantityEvent(event) {
      event.preventDefault();
      const currentTarget = event.currentTarget;
      this.toggleProductQuantity(currentTarget);
      this.buildSelectedProductArray(currentTarget);
      this.totalSelectedQtyValidation(currentTarget);
      this.checkoutEnableValidation();
      this.setUrl(currentTarget);
    }

  /**
   * Validates selected quantity total on product selection
   * @param {HTMLElement} trigger - Selected quantity
  */
  inputChangeSubProduct(trigger) {
    if(isNaN(trigger.value) || trigger.value == "" || trigger.value < 0){
      trigger.value = 0;
    }

    if(trigger.value > parseInt(trigger.max)) {
      trigger.value = parseInt(trigger.max);
    }

    if(trigger.value < parseInt(trigger.min)) {
      trigger.value = parseInt(trigger.min);
    }

    const bundleMax = trigger.closest('.stay-ai-bundle-product__cards').dataset.bundleMax;
    const bundleQuantity = this.getSelectedChildProductQty(trigger);

    if((bundleQuantity > bundleMax) && bundleMax > 0) {
      let bundleDif = bundleQuantity - bundleMax;
      if(trigger.value >= bundleDif) {
        //reduce quantity to stay within bundle max
        trigger.value = (trigger.value - bundleDif);
      } else {
        //something went wrong, reset all values to min
        this.querySelectorAll('.stay-ai-bundle-product__quantity').forEach((input) => {
          input.value = parseInt(input.min);
        });
      }
    }
    this.updateQuantityDisplay(trigger);
    this.updateBundlePrice(trigger);
  }

  /**
   * Toggle product quantity and update display based on selector type
   * @param {EventListener} target - Product add click event listener
   */
  toggleProductQuantity(target) {
    const selectorType = target.classList.contains("lsg-bundle-product-select-quantity-minus") ? "minus" : "plus";
    let selectedQuantity = target.closest(".lsg-bundle-product-select-quantity-wrap").querySelector(".stay-ai-bundle-product__quantity");
    const bundleQuantity = this.getSelectedChildProductQty(target);

    switch(selectorType) {
      case "plus":
        if (bundleQuantity >= Number(this.bundleMax)) return;
        selectedQuantity.value = selectedQuantity.value >= parseInt(selectedQuantity.max)
          ? Number(selectedQuantity.max)
          : Number(selectedQuantity.value) + 1;
        break;
      case "minus":
        selectedQuantity.value = selectedQuantity.value <= parseInt(selectedQuantity.min)
          ? 0
          : Number(selectedQuantity.value) - 1;
        break;
    }
    this.updateBundlePrice()
    this.updateQuantityDisplay(selectedQuantity);
    this.mirrorQuantityDisplay(selectedQuantity);
  }

  /**
   * Updates options on selected products
   * @param {HTMLElement} input - Selected quantity input
   */
  mirrorQuantityDisplay(input) {
    const productID = input.dataset.product;
    const productInputs = this.querySelectorAll('[data-product="' + productID + '"].stay-ai-bundle-product__quantity');
    
    productInputs.forEach((productInput) => {
      if (productInput === input || !this) return;

      this.inputChangeSubProduct(productInput);
    });
  }

  /**
   * Updates selected quantity total on individual child products
   * @param {HTMLElement} qtySelector - Selected quantity selector
   */
  updateQuantityDisplay(qtySelector) {
      const inputWrap = qtySelector.closest('.lsg-bundle-product-select-quantity-wrap');
      const inputDisplay = qtySelector.parentNode.querySelector('.stay-ai-bundle-product__quantity-display');
      
      inputWrap.classList.toggle("no-quantity", qtySelector.value <= 0);
      
      if(inputDisplay) {
        inputDisplay.innerHTML = qtySelector.value;
      }
  }

  updateBundlePrice() {
    const oneTimePriceEls = this.querySelectorAll("[data-bundle-otp-price]");
    const subscriptionPriceEls = this.querySelectorAll("[data-bundle-sub-price]");
    const totalPriceEls = this.querySelectorAll("[data-bundle-total]");
    const frequency = this.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate) option:checked');
    const productCardsBlock = this.querySelector('.stay-ai-bundle-product__cards');
    const productCardsQtyInput = productCardsBlock.querySelectorAll(".stay-ai-bundle-product__quantity");
    let interval = this.classList.contains("lsg-bundle--otp-selected") ? "otp" : "sub";

    let otpSubtotal = 0;
    let subSubtotal = 0;

    productCardsQtyInput.forEach((quantityEl) => {
      let quantity = Number(quantityEl.value);
      let price = Number(quantityEl.dataset.price);
      const discountType = frequency?.dataset?.discountType || null;
      const discountValue = frequency?.dataset?.discountValue || null;
      let discount = 0;

      otpSubtotal = otpSubtotal + (quantity * price)

      if (!productCardsBlock && !discountType && !discountValue) { return; }

      switch (discountType) {
        case "percentage":
          discount = (price * Number(discountValue)) / 100;
          break;
        case "fixed_amount":
          discount = Number(discountValue);
          break;
        case "price":
          discount = price - Number(discountValue);
          break;
      }

      subSubtotal = subSubtotal + (quantity * (price - discount))
    })

    if(subSubtotal <= 0) subSubtotal = 0;

    otpSubtotal = otpSubtotal > 0 ? otpSubtotal + this.product.price : otpSubtotal + this.product.price

    if (subSubtotal >= 0) {
      const discountType = frequency?.dataset?.discountType || null;
      const discountValue = frequency?.dataset?.discountValue || 0;
      let discount = 0;
      switch (discountType) {
        case "percentage":
          discount = (this.product.price * Number(discountValue)) / 100;
          break;
        case "fixed_amount":
          discount = Number(discountValue);
          break;
        case "price":
          discount = this.product.price - Number(discountValue);
          break;
        }
      if(discount < 0) { discount = 0; }
      subSubtotal = subSubtotal + (this.product.price - discount);
    }

    const currency = Shopify?.currency?.active || "USD";
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      currency,
      style: "currency",
    });

    oneTimePriceEls.forEach((el) =>  el.innerHTML = currencyFormatter.format(otpSubtotal / 100));
    subscriptionPriceEls.forEach((el) => el.innerHTML = currencyFormatter.format(subSubtotal / 100));
    totalPriceEls.forEach((el) => 
      el.innerHTML = currencyFormatter.format(`${interval === 'otp' ? otpSubtotal : subSubtotal}` / 100)
    );
  }

  /**
   * Gets total quantity of selected child product
   * @returns {number}
   */
    getSelectedChildProductQty() {
      const productSetList = this.querySelector(".stay-ai-bundle-product__cards");
      let quantity = 0;
  
      if (!productSetList) return -1;
  
      const productListQuantity = productSetList.querySelectorAll(".stay-ai-bundle-product__quantity");
      productListQuantity.forEach((inputEl) => (quantity += Number(inputEl.value)));
  
      return quantity;
    }

  getBundleInterval(trigger) {
      //checks if the bundle is set to display OTP or suscription options
      let bundleBlock = this.getBundleBlock(trigger);
      if(bundleBlock.classList.contains('lsg-bundle--has-interval-select')) {
          if(bundleBlock.classList.contains('lsg-bundle--otp-selected')) {
              return 'otp';
          }
          if(bundleBlock.classList.contains('lsg-bundle--sub-selected')) {
              return 'sub';
          }
      }
      if(bundleBlock.classList.contains('lsg-bundle--only-otp')) {
          return 'otp';
      }
      if(bundleBlock.classList.contains('lsg-bundle--only-sub')) {
          return 'sub';
      }
      return 'err';
  }

  /**
   * Get selected bundle block
   * @param {HTMLElement} trigger
   * @return {HTMLElement}
   */
  getBundleBlock(trigger) {
    return trigger.closest('.lsg-bundle-block');
  }

  getGuid() {
      let d = new Date().getTime();
      let d2 =  (performance && performance.now && (performance.now() * 1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
          let r = Math.random() * 16;
          if (d > 0) {
              r = (d + r) % 16 | 0;
              d = Math.floor(d / 16);
          } else {
              r = (d2 + r) % 16 | 0;
              d2 = Math.floor(d2 / 16);
          }
          return (c == 'x' ? r: (r & 0x7 | 0x8)).toString(16);
      });
  }

  /**
   * Groupes all selected products
   * @param {HTMLElement} trigger - Selected quantity input
   */
  buildSelectedProductArray = (trigger) => {
    const method = trigger.classList.contains("lsg-bundle-product-select-quantity-minus") ? "minus" : "plus";
    const triggeredProductWrapper = trigger.closest('.lsg-bundle-product-select-wrapper');
    const variantID = triggeredProductWrapper.getAttribute('data-lsg-bundle-variant-select-id');
    const productTitle = triggeredProductWrapper.querySelector('.lsg-bundle-product-select-title').innerHTML;
    const bundleIndex0 = [...this.parentNode.children].indexOf(this);
    
    switch(method) {
        case 'minus':
          if (this.productSelectionButtonClicked == true) {
            this.selectedProducts[bundleIndex0].splice(this.productSelectionIndex, 1);
            this.productSelectionButtonClicked = false
          }
          else {
            this.productSelectionIndex = this.selectedProducts[bundleIndex0].findLastIndex(p => p.selectedVariantId == variantID);
            this.selectedProducts[bundleIndex0].splice(this.productSelectionIndex, 1);    
          }
          break;
        case 'plus':
          const productImageUrl = triggeredProductWrapper.querySelector('img').src;
          const productImageAlt = triggeredProductWrapper.querySelector('img').alt;
          let selectedProductData = {
            selectedProductImageUrl: productImageUrl,
            selectedVariantId: variantID,
            selectedProductTitle: productTitle,
            selectedProductImageAlt: productImageAlt,
          };
          this.selectedProducts[bundleIndex0].push(selectedProductData);
          break;
    }
    this.updateSelectedProductGUI(trigger);
  }

  updateSelectedProductGUI = () => {
    const bundleIndex0 = [...this.parentNode.children].indexOf(this);
    this.classList.toggle("has-selected-product", this.selectedProducts[bundleIndex0].length > 0)

    this.selectedVariantWrapper.forEach((productWrapper, i) => {
      const selectedProductData = this.selectedProducts[bundleIndex0][i];
      const productWrapperImage = productWrapper.querySelector("[data-bundle-builder-selected-product-image]");
      const productWrapperTitle = productWrapper.querySelector("[data-bundle-builder-selected-product-title]");

      productWrapper.setAttribute("data-bundle-builder-selected-variant-id", selectedProductData?.selectedVariantId || '');
      productWrapperImage.src = selectedProductData?.selectedProductImageUrl || "";
      productWrapperImage.alt = selectedProductData?.selectedProductImageAlt || "";
      productWrapperTitle.innerHTML = selectedProductData?.selectedProductTitle || "";
      
      if (selectedProductData) {
        productWrapper.classList.add("active");
      } else {
        productWrapper.classList.remove("active");
      }
    });   
  }

  /**
   * Sets active bundle on enabled grouped bundles
   * @param {HTMLElement} trigger - Selected grouped bundle element
   */
  setActiveBundle(trigger) {
    const bundleIndex = trigger.dataset.bundleIndex;
    const bundleWrapper = trigger.closest('.lsg-bundle-wrapper');
    const bundleBlocks = bundleWrapper.querySelectorAll('.lsg-bundle-block');
    const targetBundle = bundleWrapper.querySelector(`[bundle-index="${bundleIndex}"].lsg-bundle-block`);
    
    if(targetBundle) {
      bundleBlocks.forEach((bundleBlock) => {
        if(bundleBlock.bundleIndex != bundleIndex) {
          bundleBlock.classList.remove('lsg-bundle-block-active');
        } else {
            bundleBlock.classList.add('lsg-bundle-block-active');
        }
      });
      this.updateSelectedProductGUI(trigger);
      this.setUrl(targetBundle.querySelector('form'));
    }
  }

  checkParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const bundleBlocks = document.querySelectorAll('.lsg-bundle-block');
    const queryString = window.location.search;
    const bundles = urlParams.getAll('bundle');
    const bundle_interval = urlParams.getAll('bundle_interval');
    const bundle_interval_frequency = urlParams.getAll('bundle_interval_frequency');
    const hasRequiredParams =
      bundles.length > 0 ||
      urlParams.has("bundle_index") ||
      urlParams.has("bundle_interval") ||
      urlParams.has("bundle_interval_frequency");
    let bundle_index = urlParams.getAll("bundle_index");
    
    if (!hasRequiredParams) return;

    bundle_index = bundle_index.length > 0 ? bundle_index[0] : 0;
    const bundleBlock = bundleBlocks[bundle_index];

    if (bundle_index > 0) { 
      const bundleBlockSelects = document.querySelectorAll(".lsg-bundle-size-select .lsg-bundle-size-select-el");
      bundleBlockSelects[bundle_index].click();
    }

    bundles.forEach(el => {
      const item = el.split('_')
      const id = item[0];
      const quantity = item[1];
      const quantityInput = bundleBlock.querySelector(`.stay-ai-bundle-product__quantity[data-product="${id}"]`);

      this.updateQuantityInput(quantityInput, quantity);
    });

    bundle_interval.forEach((el) => {
      const packSizeSelectorItem = bundleBlock.querySelector(`.lsg-bundle-interval-select input[name^="bundle_interval_select_"][value="${bundle_interval}"]`);
      if (!packSizeSelectorItem) return;

      packSizeSelectorItem.checked = true;
      this.updateInterval(packSizeSelectorItem);
      this.checkoutEnableValidation(packSizeSelectorItem);
    });
    bundle_interval_frequency.forEach((el) => {
      const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select');

      if (!bundleIntervalFrequencySelect) return

      bundleIntervalFrequencySelect.value = el;
      this.updateFrequency(bundleIntervalFrequencySelect);
    });
    if (history.pushState) {
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + queryString;
      window.history.pushState({path: newurl}, '', newurl);
    }
  }

    /**
   * Updates individual product selection quantity inputs
   * @param {HTMLElement} quantityInput - Child product quantity input element
   * @param {Number} quantity - Total selected quantity on child product
   * 
   */
    updateQuantityInput(quantityInput, quantity) {
      if (!quantityInput) return;
  
      quantityInput.value = parseInt(quantity, 10) - 1;
      const quantityInputPlus = quantityInput.closest(".stay-ai-bundle-product__quantity-wrapper").querySelector(`.stay-ai-bundle-product__quantity-selector--plus`);
  
      for (let i = 0; i < quantity; i++) {
        quantityInput.value = i;
        this.toggleProductQuantity(quantityInputPlus);
        this.buildSelectedProductArray(quantityInputPlus);
        this.totalSelectedQtyValidation(quantityInputPlus);
        this.checkoutEnableValidation(quantityInputPlus);
      }
    }

  /**
   * Set bundle url params
   * @param {EventListener} clickedEl - Clicked element event listener
   */
  setUrl(clickedEl) {
    const bundleBlockWrapper = clickedEl.closest('.lsg-bundle-wrapper');
    if (bundleBlockWrapper && !bundleBlockWrapper.hasAttribute('data-lsg-bundle-set-url')) {
      return false;
    }

    const bundleBlock = this.getBundleBlock(clickedEl);
    const quantityInput = bundleBlock.querySelectorAll('.stay-ai-bundle-product__quantity');
    let url = '?';
    let paramName = 'bundle';
    quantityInput.forEach((el) => {
      const value = el.value;
      if (value > 0) {
        url += (url == '?') ? '' : '&';
        url += `${paramName}=${el.getAttribute('data-product')}_${value}`;
      }
    });
    const selectedBundle = bundleBlock.closest('.lsg-bundle-wrapper').querySelector('.lsg-bundle-block.lsg-bundle-block-active');
    if (selectedBundle != null) {
      paramName = 'bundle_index';
      url += (url == '?') ? '' : '&';
      url += `${paramName}=${Array.from(selectedBundle.parentNode.children).indexOf(selectedBundle)}`;
    }
    const bundleIntervalOption = bundleBlock.querySelector('.lsg-bundle-interval-select input[type="radio"]:checked');
    if (bundleIntervalOption != null) {
      paramName = 'bundle_interval';
      url += (url == '?') ? '' : '&';
      url += `${paramName}=${bundleIntervalOption.value}`;
      if (bundleIntervalOption.value == 'sub') {
        paramName = 'bundle_interval_frequency';
        url += (url == '?') ? '' : '&';
        const bundleIntervalFrequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select');
        if (bundleIntervalFrequencySelect != null) {
          url += `${paramName}=${bundleIntervalFrequencySelect.value}`;
        }
      }
    }
    if (history.pushState) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
      window.history.pushState({path: newurl}, '', newurl);
    }
  }

  /**
   * Validation to make sure total selected quantity doesn't exceed max or min value
   */
  totalSelectedQtyValidation() {
    const productSetList = this.querySelector('.stay-ai-bundle-product__cards');
    const quantityIncrementButtons = productSetList.querySelectorAll('.stay-ai-bundle-product__quantity-selector');
    const bundleQuantity = this.getSelectedChildProductQty();
    const bundleMax = productSetList.dataset.bundleMax || 0;

    quantityIncrementButtons.forEach((quantitySelector) => {
      const productDetails = quantitySelector.parentElement.querySelector(".stay-ai-bundle-product__quantity");
      const totalQty = productDetails.value;
      const maxValue = Number(productDetails.max);
      const minValue = Number(productDetails.min);
      const selectorType = quantitySelector.classList.contains("stay-ai-bundle-product__quantity-selector--minus")
        ? "minus"
        : "plus";

      quantitySelector.disabled = selectorType === "minus"
        ? totalQty <= 0 || totalQty <= minValue
        : totalQty >= maxValue || (Number(bundleMax) > 0 && bundleQuantity >= Number(bundleMax));
    });
  }

  checkoutEnableValidation() {
    const bundleQuantity = this.getSelectedChildProductQty();
    const quantityToAdd = this.bundleMin - bundleQuantity;
    const hasRequiredProductQuantity = bundleQuantity >= this.bundleMin && (bundleQuantity <= this.bundleMax || this.bundleMax < this.bundleMin)
    
    if (!this.addToCartButton) return;

    this.addToCartButton.disabled = !hasRequiredProductQuantity;
    this.addToCartButton.classList.toggle("disabled", !hasRequiredProductQuantity);
    this.classList.toggle("bundle-checkout-enabled", hasRequiredProductQuantity);
    this.addToCartButtonQuantity.innerHTML = hasRequiredProductQuantity ? "" : quantityToAdd;
  }

  addToCart(trigger) {
    const bundleID = this.getGuid();
    const bundleForm = this.querySelector('.lsg-bundle-form');
    const bundleProductID = bundleForm.querySelector('input[name="id"]').value;
    const bundleSellingPlan = bundleForm.querySelector('input[name="selling_plan"]').value;
    const bundleProductList = this.querySelector('.stay-ai-bundle-product__cards');
    const bundleProductListInputs = bundleProductList.querySelectorAll('.stay-ai-bundle-product__quantity');
    const bundleSelectedProducts = [...bundleProductListInputs].filter( (list) => list.value > 0);
    let bundleProductQuantity = bundleSelectedProducts.reduce((acc, curr) => acc + Number(curr.value), 0);

    if (bundleProductQuantity > this.bundleMax || bundleProductQuantity < this.bundleMin ) {
      return false;
    }

    const cartItems = bundleSelectedProducts.map((bundleProduct) => {
      return {
        id: bundleProduct.dataset.product,
        quantity: parseInt(bundleProduct.value),
        properties: {
          _bundle_id: bundleID,
        },
        selling_plan: bundleSellingPlan,
      };
    });

    let bundleCart = {
      items: [
        {
          id: bundleProductID,
          quantity: 1,
          properties: {
            _bundle_id: bundleID,
            _bundle_parent: true,
            _bundle_max: this.bundleMax,
            _bundle_min: this.bundleMin,
          },
          selling_plan: bundleSellingPlan,
        },
        ...cartItems,
      ],
    };

    let drawer = document.querySelector('cart-drawer');
    bundleCart.sections = drawer.getSectionsToRender().map((section) => section.id);
    bundleCart.sections_url = window.location.pathname

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bundleCart)
    })
    .then((response) => {
      return response.json();
    }).then(cart => {
      // cart.sections = drawer.getSectionsToRender().filter((section) => section.id === 'cart-drawer')
      drawer.renderContents(cart);
      drawer.open();
    })
    .catch((error) => {
      console.error(error);
    });
  }

  /**
   * Update selling plan price and id
   * @param {HTMLElement} trigger
   */
  updateFrequency(trigger) {
    //Render price and assign selling_plan in the form
    this.updateBundlePrice(trigger);
    this.updateSellingPlan(trigger);
  }

  /**
   * Updates bundle block classes, resets displayed prices, and sets the selling_plan input value
   */
  updateInterval(trigger) {
    const bundleBlock = this.getBundleBlock(trigger);
    const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    const frequencySelect = bundleBlock.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');

    switch(trigger.value) {
      case 'otp':
        bundleBlock.classList.remove('lsg-bundle--sub-selected');
        bundleBlock.classList.add('lsg-bundle--otp-selected');
        sellingPlanInput.value = '';
        break;
      case 'sub':
        bundleBlock.classList.remove('lsg-bundle--otp-selected');
        bundleBlock.classList.add('lsg-bundle--sub-selected');
        sellingPlanInput.value = frequencySelect.value;
        break;
    }

    this.updateBundlePrice(trigger);
    this.updateSellingPlan(trigger);
  }

  updateSellingPlan() {
    const sellingPlan = this.querySelector('.lsg-bundle-form input[name="selling_plan"]');
    
    if (!sellingPlan) return;
    if (!this.classList.contains('lsg-bundle--sub-selected')) {
      sellingPlan.value = "";
      return;
    }

    const frequencySelect = this.querySelector('.lsg-bundle-interval-frequency-select:not(.is-duplicate)');
    sellingPlan.value = frequencySelect ? frequencySelect.value : "";
  }

  loadBundleObserver() {
    const bundleObserver = new IntersectionObserver(([entry]) => {
    const bundleBlock = entry.target.closest('.lsg-bundle-block');
    
    if (!bundleBlock) return

    bundleBlock.classList.remove('summary-is-below', 'summary-is-above', 'summary-is-visible');

    if (entry.isIntersecting) {
      bundleBlock.classList.add('summary-is-visible');
      return
    }

    entry.boundingClientRect.top > 0 ? bundleBlock.classList.add('summary-is-below') : bundleBlock.classList.add('summary-is-above');
  });
  const buyboxes = document.querySelectorAll('.lsg-bundle-summary-block');
  buyboxes.forEach((buybox) => {
      bundleObserver.observe(buybox);
  });
  }

  loadBundleFooterObserver() {

    const bottomObserver = new IntersectionObserver(([entry]) => {
      const bundleBlocks = document.querySelectorAll('.lsg-bundle-block');
      if(entry.isIntersecting) {
          bundleBlocks.forEach((bundleBlock) => {
              bundleBlock.classList.add('is-scroll-bottom');
          })
      } else {
          bundleBlocks.forEach((bundleBlock) => {
              bundleBlock.classList.remove('is-scroll-bottom');
          })
      }
  }, {
      threshold: 1
  });
  const subFooter = document.querySelector('.io-sub-footer');
  if (subFooter) {
      bottomObserver.observe(subFooter);
  }
  }
  
}

customElements.define(`stay-ai-bundle-product`, StayAIBundleProduct);
